import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Spinner } from 'react-bootstrap-5';
import { fetchContact } from '../../helpers/connect_api';
import ContactInformation from './contact_information.js';

export default function Contact({ contactId }) {
  const [contact, setContact] = useState();

  useEffect(() => {
    fetchContact(contactId).then(setContact);
  }, []);

  if (!contact) return <Spinner animation="border" variant="primary" />;

  return (
    <Card>
      <Card.Body>
        <Row className="align-items-center">
          <Col className="text-muted fw-bold">Contact</Col>
        </Row>
        <div className="fs-large fw-bold mb-4">{contact.name}</div>
        <ContactInformation contact={contact} />
      </Card.Body>
    </Card>
  );
}

Contact.propTypes = {
  contactId: PropTypes.number.isRequired
};
